import React, { useCallback, useEffect, useState, useContext } from 'react';
import Tabs from '../components/Tabs';
import Filter from '../components/Filter';
import { Grid } from '@mui/material';
import fieldsTables from '../utils/fieldsTables';
import showColumns from '../utils/showColumns';
import { showFilters } from '../utils/configFilters';
import Table from '../components/Table';
import { useSearchParams } from 'react-router-dom';
import EmptyState from '../components/EmptyState';
import Loading from '../components/Loading';
import { LanguageContext } from '../App';
import { getUsuarios, updateUsuarioStatus } from '../apis/apiUsuario';
import InputCustom from '../components/InputCustom';

function Usuario() {
  const [loading, setLoading] = useState<boolean>(true)
  const [selectedTab, setSelectedTab] = useState<string>("");
  const [usuarios, setUsuarios] = useState<Usuario[]>([])
  const [usuariosFiltrados, setUsuariosFiltrados] = useState<Usuario[]>([])
  const [buscaUsuario, setBuscaUsuario] = useState("");
  const [searchParams] = useSearchParams();
  const { translations, setLanguage } = useContext(LanguageContext);
  const [datePlaceholder, setDatePlaceholder] = useState<string>("");

  const handleChangeTab = (event: React.SyntheticEvent, value: string) => {
    setSelectedTab(value);
  };

  const handleGetUsuarios = useCallback(async (filters: FiltersType) => {
    setLoading(true)

    const params = {
      genericStatus: filters.genericStatus
    }

    const token = searchParams.get('token')

    const result = await getUsuarios(params, token);

    if (result.status === 200) {
      /* const mappedResult: Usuario[] = result.data.map((usuario: Usuario) => ({
        ...usuario
      })) */
      setUsuarios(result.data);
      setUsuariosFiltrados(result.data)
    }

    setLoading(false)
    
  }, [searchParams]);

  const handleSearchButton = (filters: FiltersType) => {
    const mappedFilters = {
      ...filters,
    }
    handleGetUsuarios(mappedFilters)
  }

  const handleUpdateUsuarioStatus = async (usuario: Usuario) => {

    if (usuario.usuCodigo) {

      const token = searchParams.get('token')

      const result = await updateUsuarioStatus({ usuMaster: !usuario.usuMaster, usuCodigo: usuario.usuCodigo}, token);

      if (result.status === 200) {
        handleGetUsuarios({
          genericStatus: ''
        })
      }
    }
  }

  const handleBuscaUsuario = (event: any) => {
    const {
      target: { value },
    } = event;

    setBuscaUsuario(value)
    if (value.length > 0) {
      const valueSplit = value.toString().toUpperCase().split(" ");
      setUsuariosFiltrados(usuarios.filter((usuario: Usuario) => (
        usuario.usuCodigo.includes(value.toString()) ||
        valueSplit.every((split: string) => usuario.usuNome.includes(split)) ||
        (usuario.usuLogin.toUpperCase()).includes(value.toString().toUpperCase()) ||
        (usuario.usuEmail.toUpperCase()).includes((value.toString().toUpperCase())
      ))))
    } else {
      setUsuariosFiltrados(usuarios)
    }
  };

  useEffect(() => {

    if (selectedTab !== "") {
      handleGetUsuarios({
        genericStatus: ''
      });
    }

  }, [handleGetUsuarios, selectedTab]);

  useEffect(() => {

    const initialTab = searchParams.get('indicador') || "listar_usuarios"
    const languageParam = searchParams.get('language') || 'pt'
    setLanguage(languageParam)
    setSelectedTab(initialTab)

  }, [searchParams, setLanguage]);

  useEffect(() => {
    if (translations) setDatePlaceholder(translations["lbl.react.filtro.por.data.criacao"]);
  }, [translations]);

  return (
    <Grid container justifyContent="center">
      { translations &&
        <Grid item xs={12}>
          <div className="page-body">
            <span className="page-title">
              { translations["lbl.react.usuarios"] }
            </span>
            <Grid container rowSpacing={2} justifyContent="center">
              <Grid item xs={12} display={"none"}>
                { selectedTab &&
                  <Tabs handleChange={handleChangeTab} value={selectedTab} labels={[{ label: translations["lbl.react.usuarios"], name: "listar_usuarios" }]}/>
                }
              </Grid>
              <Grid item xs={12}>
                <Filter
                  handleSearch={handleSearchButton}
                  datePlaceholder={datePlaceholder}
                  selectedTab={selectedTab}
                  selectRange={true}
                  showFilters={showFilters.listar_usuarios}
                  onlyMonths={false}
                  dateFormat="MM/yyyy"
                />
              </Grid>
              { loading === false ?
                <Grid item xs={12} pt={0}>
                  <Grid container item xs={12} justifyContent={"end"}>
                    <Grid item xs={4}>
                      <span className="input-label">{`${translations["lbl.react.buscar"]}:`}</span>
                      <InputCustom
                        placeholder={''}
                        controlledValue={buscaUsuario}
                        name={'buscaUsuario'}
                        handleChange={handleBuscaUsuario}
                      />
                    </Grid>
                  </Grid>
                  {selectedTab === "listar_usuarios" && (
                    1>0 ?
                      <div>
                        <Grid item xs={12}>
                          <Grid container item xs={12} pb={2} mb={3}>
                            <Table
                              columns={fieldsTables(translations, null, handleUpdateUsuarioStatus).Usuarios}
                              rows={usuariosFiltrados}
                              idColumn='usuCodigo'
                              sortColumn='usuCodigo'
                              hasCheckbox={false}
                              tableTitle={""}
                              tableSubTitle={""}
                              name="usuarios"
                              printButton={false}
                              showColumns={showColumns.usuarios}
                              handleCloseTable={() => {}}
                              border={false}
                            />
                          </Grid>
                        </Grid>
                      </div>
                    :
                      <div>
                        <EmptyState />
                      </div>
                    )
                  }
                </Grid>
                :
                <Loading />
              }
            </Grid>
          </div>
        </Grid>
      }
    </Grid>
  );
}

export default Usuario;